import { isHydraRoute } from '@/services/router/route-ownership';

const COMPARISON_ORIGIN = 'https://hydra.local';

export function getNextActiveRoute(activeRoute: string, currentPath: string) {
  const comparableCurrentPath = getComparableRoutePath(currentPath);

  if (activeRoute === '') {
    return comparableCurrentPath;
  }

  const comparableActiveRoute = getComparableRoutePath(activeRoute);
  const isCurrentPathHydraOnly = isHydraRoute(comparableCurrentPath);
  const isActiveRouteHydraOnly = isHydraRoute(comparableActiveRoute);

  if (isCurrentPathHydraOnly && isActiveRouteHydraOnly && comparableActiveRoute !== comparableCurrentPath) {
    return comparableCurrentPath;
  }

  return null;
}

export function shouldSyncActiveRouteToRouter(activeRoute: string, currentPath: string, childAppLoaded: boolean) {
  const comparableActiveRoute = getComparableRoutePath(activeRoute);
  const comparableCurrentPath = getComparableRoutePath(currentPath);

  // Active-route sync only lets embedded apps pull the shell router into their
  // URLs. Hydra-owned routes are written by Hydra itself via getNextActiveRoute.
  return (
    childAppLoaded &&
    !isHydraRoute(comparableActiveRoute) &&
    !isHydraRoute(comparableCurrentPath) &&
    !isEmptyActiveRoute(activeRoute) &&
    comparableActiveRoute !== comparableCurrentPath
  );
}

export function getRouterLocationPath(location: { pathname: string; searchStr: string; hash: string }) {
  const hash = location.hash === '' || location.hash.startsWith('#') ? location.hash : `#${location.hash}`;
  return `${location.pathname}${location.searchStr}${hash}`;
}

function getComparableRoutePath(route: string) {
  try {
    const url = new URL(route, COMPARISON_ORIGIN);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return route;
  }
}

function isEmptyActiveRoute(activeRoute: string) {
  return activeRoute.trim() === '';
}
